import { get } from 'lodash';

export const getCurrencyPrefix = (currencyCode) => {
	const currencySignMapping = {
		USD: '$',
		EUR: '€',
		GBP: '£',
	};
	return get(currencySignMapping, currencyCode, '');
};

export const getCurrencyDecimalPlaces = (countryCode) => {
	const threeDecimalCountries = ['BHD', 'KWD'];

	if (countryCode === 'JPY') return 0;
	if (threeDecimalCountries.includes(countryCode)) return 3;
	return 2;
};
export const internationalNumberFormatter = (currency = '', decimalLimit, amount = 0) => {
	let formattedValue = '';
	try {
		formattedValue = new Intl.NumberFormat('en-GB', {
			style: 'currency',
			currency,
			currencyDisplay: 'code',
			minimumFractionDigits: decimalLimit,
			maximumFractionDigits: decimalLimit,
		}).format(Number(amount));
		return formattedValue;
	} catch (e) {
		return formattedValue;
	}
};
